module.exports = __webpack_public_path__ + "static/music1-3e4b7eed914ce986a087eaf05d023035.gif";